import React from 'react';
import TeacherSessionCard from '../../components/teacher/TeacherSessionCard';
import { useTeacherSessions } from '../../hooks/useTeacherSessions';

const TeacherHistory = () => {
  const sessions = useTeacherSessions('history');
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="teacher-history-page">
      <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-2">Session History</h1>
      <p className="text-base md:text-lg text-slate-600 mb-8">Past, completed and cancelled sessions.</p>
      {sessions === null ? (
        <p className="text-slate-500">Loading...</p>
      ) : sessions.length === 0 ? (
        <div className="py-14 text-center rounded-2xl border border-dashed border-slate-300 bg-white text-slate-500" data-testid="teacher-no-history">
          No past sessions yet.
        </div>
      ) : (
        <div className="space-y-3">{sessions.map((s) => <TeacherSessionCard key={s.id} s={s} showLink={false} />)}</div>
      )}
    </div>
  );
};

export default TeacherHistory;
